var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrap"},[(_vm.imgSrc !== undefined)?_c('img',{staticClass:"button-icon",attrs:{"src":_vm.imgSrc}}):(_vm.buttonText)?_c('div',[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }